export default __webpack_public_path__ + "static/media/snap-svg.98267c0c.svg";